export default "__VITE_ASSET__83c9fcbd__"